import React from 'react'

const defaultState = {
  refreshUser: () => true,
  user: null
}

const { Provider, Consumer } = React.createContext(defaultState)

export { Provider, Consumer, defaultState }
